import { render, staticRenderFns } from "./fancyHtml.vue?vue&type=template&id=a5893dc0"
import script from "./fancyHtml.vue?vue&type=script&lang=js"
export * from "./fancyHtml.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports